import { PayloadAction } from "@reduxjs/toolkit";
import {
  TRIGGER_PF_INSUREDS_FETCH_REQUEST,
  TRIGGER_PF_INSUREDS_UPDATE_REQUEST,
  pfInsuredsLoading,
  pfInsuredsFetchSuccess,
  pfInsuredsFetchError,
  pfInsuredUpdateLoading,
  pfInsuredUpdateSuccess,
  pfInsuredUpdateError,
} from "app/redux/features/pf-insureds";
import { makeRequest } from "app/utils/makeRequest";
import { all, call, put, takeLatest } from "redux-saga/effects";

function* pfInsuredsRequest(
  actions: PayloadAction<{
    proposalId: string;
  }>,
): Generator<any, void, any> {
  try {
    const {
      payload: { proposalId },
    } = actions;
    yield put(pfInsuredsLoading());
    const response = yield call(() =>
      makeRequest("pfInsuredsWithCompanyProduct").get(proposalId, true),
    );
    yield put(pfInsuredsFetchSuccess(response.data));
  } catch (err: any) {
    yield put(pfInsuredsFetchError(err));
  }
}

function* pfInsuredUpdateRequest(
  actions: PayloadAction<{
    proposalId: string;
    userId: string;
    insuranceCompanyId: string;
    insuranceProductId: string;
  }>,
): Generator<any, void, any> {
  try {
    const {
      payload: { proposalId, userId, insuranceCompanyId, insuranceProductId },
    } = actions;
    yield put(pfInsuredUpdateLoading());
    const response = yield call(() =>
      makeRequest("pfInsuredsWithCompanyProduct").patch(
        {
          userId,
          insuranceCompanyId,
          insuranceProductId,
        },
        proposalId,
        true,
      ),
    );
    yield put(pfInsuredUpdateSuccess(response.data));
    // Refetch insureds after update
    yield put({
      type: TRIGGER_PF_INSUREDS_FETCH_REQUEST,
      payload: { proposalId },
    });
  } catch (err: any) {
    yield put(pfInsuredUpdateError(err));
  }
}

function* pfInsuredsFetchSaga() {
  yield takeLatest(TRIGGER_PF_INSUREDS_FETCH_REQUEST, pfInsuredsRequest);
}

function* pfInsuredUpdateSaga() {
  yield takeLatest(TRIGGER_PF_INSUREDS_UPDATE_REQUEST, pfInsuredUpdateRequest);
}

export default function* pfInsuredsSagaRoot() {
  yield all([pfInsuredsFetchSaga(), pfInsuredUpdateSaga()]);
}
